import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3077383669/src/node_modules/@mui/material/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3077383669/src/node_modules/@mui/material/Chip/Chip.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3077383669/src/node_modules/@mui/material/Typography/Typography.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3077383669/src/src/lib/components/ArchiveSidebar.tsx");
